import { useMemo } from 'react'
import {
  getPasswordChecks,
  getPasswordScore,
  isPasswordSecure,
  type PasswordChecks,
} from '../utils/auth.utils'

export type PasswordRules = {
  score: number
  checks: PasswordChecks
  isSecure: boolean
}

export function usePasswordRules(password: string): PasswordRules {
  return useMemo(
    () => ({
      score: getPasswordScore(password),
      checks: getPasswordChecks(password),
      isSecure: isPasswordSecure(password),
    }),
    [password],
  )
}
